export default [
  {
    path: '/salesDashboard',
    meta: {
      title: '带货数据监控',
    },
    component: () =>
      import(
        /* webpackChunkName: "vitara" */ '@/pages/salesDashboard/index.vue'
      ),
  },
]
